<template>
    <v-card :loading="loading">
        <v-card-title>
            Assign to Assembly Work Order
        </v-card-title>
        <v-card-text>
            <p>
                Select an assembly work order and the quantity to assign.
            </p>
            <v-autocomplete
                v-model="selectedWorkOrderId"
                :items="assemblyWOs"
                item-text="code"
                item-value="id"
                label="Assembly Work Order"
                class="mt-4"
                hide-details
                clearable
                no-data-text="No assembly work orders available"
            ></v-autocomplete>
            <v-text-field
                v-model="quantity"
                label="Quantity"
                type="number"
                class="mt-4"
                hide-details
            ></v-text-field>
        </v-card-text>
        <v-card-actions>
            <!-- Add action buttons here -->
            <v-btn color="error" @click="closeDialog">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="assign"
                :disabled="
                    loading ||
                        !selectedWorkOrderId ||
                        +quantity <= 0 ||
                        +quantity > partNumber.stockQuantity
                "
                >Assign</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
import API from '@/services/api'
import { mapMutations } from 'vuex'

export default {
    name: 'AssignAssembly',
    props: {
        partNumber: { type: Object, required: true },
        assemblyWOs: { type: Array, required: true },
    },
    data: () => ({
        loading: false,
        selectedWorkOrderId: undefined,
        quantity: 0,
    }),
    methods: {
        ...mapMutations(['setErrorItems']),
        closeDialog() {
            this.$emit('closeDialog')
        },
        async assign() {
            try {
                this.loading = true

                await API.assignQuantityFromStock({
                    workOrderId: this.selectedWorkOrderId,
                    partNumberId: this.partNumber.partNumberId,
                    quantity: this.quantity,
                })
                this.$emit(
                    'discountQuantity',
                    this.partNumber.partNumberId,
                    this.quantity
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
                this.closeDialog()
            }
        },
    },
}
</script>
